import React ,{useState,useEffect}from 'react'
import {URL} from '../../Helper/helper'
import { Link, useNavigate } from 'react-router-dom'
import { invokeGallery } from '../../ServiceCalls/ApiCalls';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './ManageGallery.css'

function ManageGallery() {
  
    const navigate = useNavigate()
    const[inputField,setInputField] = useState({
          img_name:'',
          gallery_pic:''
    })
    const[status,setStatus] = useState(false)
    const[profilePic,setProfilePic] = useState('')
    const[imgName,setImageName] = useState('')
    const[gallery,setGallery] = useState([])

    useEffect(() =>{
        if(!localStorage.getItem('user')){
            navigate('/')
        }
        async function GetData(){
            const galleryList = await invokeGallery()
            console.log(galleryList)
            setGallery(galleryList)
        }
    
        GetData()
      },[])

      const options = (method = "GET",body) =>{
        return {
            method,
            headers: {
                "content-type": "application/json"
            },
            body: JSON.stringify(body)
        }
      }

      const editGallery = (gal,index) =>{

      }
      const deleteGallery = async(tr_id,rowid) => {
        window.confirm('Are you Sure You wanna Delete the Record at Row-No - '+`${rowid+1}`)
        try{
            const delete_gallery_response = await fetch(`${URL}` + '/gallery/'+`${tr_id}`, options("DELETE"));
            if(delete_gallery_response.ok){
               // alert(`Trainer at ${rowid+1}  is Deleted !!`)
                const dataDelete = [...gallery];
                dataDelete.splice(rowid,1)
                setGallery([...dataDelete])
                toast.success('🦄 Wow Image Deleted!', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
            }
            else{
                toast.error('🦄 OOps Del Image Failed!', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
            }
        }catch(err){
            console.log(err)
        }
      }
      const handleSubmitGallery = async(e) =>{
        e.preventDefault()

    const{img_name,gallery_pic} = inputField;
    
    const formData = new FormData()
    
    formData.append('img_name',img_name)
    formData.append('gallery_pic',gallery_pic)

        try {
            const add_gallery_response = await fetch(`${URL}` + '/gallery/create',{
                method: "POST",
                body: formData
            });
            const add_gallery_data = await add_gallery_response.json();

            if(add_gallery_response.ok){
                console.log('Data',add_gallery_data)
                //alert('Trainer Added !!')
                setGallery(prev => [...prev,add_gallery_data])
                toast.success('🦄 Wow Gallery Added!', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
                reset()
            }
            else{
               // alert('Trainer Add Failed...')
               toast.error('🦄 OOps Add Gallery Failed!', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
                });
            }
    
        } catch (error) {
            console.log(error)
        }

      }
      
      const handleAddGallery = (e) =>{
        const{name,value} = e.target;
        setInputField({...inputField,[name]:value})
      }

      const handleUpdateGallery = () => {

      }
      const handleEditGallery = (e) => {

        const { name, value } = e.target;

        if (name === 'img_name')
          setImageName(value)

      }
      const reset = (e) => {
        e.preventDefault();
        setInputField({ img_name: ''});
      }

      
  return (
    <div className='wrapper-container'>
        <div className="row">
            <div className="col-md-12 col-sm-12">
                <h4 className='text-primary text-center text-decoration-underline'>Manage - Gallery</h4>
            </div>
        </div>
        <div className="row d-flex flex-row justify-content-around my-3">
                <div className="col-md-6 col-sm-12">
                    <h2 className='text-center small text-uppercase'>Add Gallery</h2>
                </div>
                <div className="col-md-6 col-sm-12">
                    <h2 className='text-center small text-uppercase'>Manage Gallery</h2>
                </div>
        </div>
        <div className='row d-flex flex-row justify-content-around my-3'>
                <div className="col-md-6 col-md-12 l-panel">
                    <form onSubmit={handleSubmitGallery} enctype="multipart/form-data">
                        <div class="container mt-5">
                          <div class="mb-3">
                              <label for="name" class="form-label">Image Title</label>
                              <input 
                                type="text" 
                                class="form-control" 
                                id="name" 
                                name="img_name"
                                value={inputField.img_name}
                                onChange={e => handleAddGallery(e)} 
                                required
                                placeholder="Enter name" autoComplete='off'/>
                          </div>
        
                          <div class="mb-3">
                              <label for="image" class="form-label">Upload Image</label>
                              <input 
                                type="file" 
                                class="form-control" 
                                id="image"
                                name="gallery_pic"
                                required
                                onChange={e => setInputField({...inputField,gallery_pic:e.target.files[0]})} 
                                placeholder="Upload Image"/>
                          </div>
                          <button 
                            type="submit" 
                            class="btn btn-primary">Submit</button>
                          <button 
                            onClick={e => reset(e)}
                            class="btn btn-secondary m-2">Reset</button>
                      
                        </div>
                    </form>

                </div>
                <div className="col-md-6 col-md-12 r-panel">
                    <table className='table table-bordered container'>
                        <thead>
                            <tr>
                                <th className='text-center small'>S.No</th>
                                <th className='text-center small'>Title</th>
                                <th className='text-center'>
                                    <i className="fa fa-cog"></i>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                gallery.length > 0 ?
                                gallery.map((t,idx) =><tr key={idx}>
                                    <td>{idx+1}</td>
                                    <td>{t.img_name}</td>
                                    
                                    <td>
                                        {/* <i className="fa fa-pencil"
                                            data-bs-toggle="modal"
                                            data-bs-target="#editModalPop"
                                            onClick={() =>editGallery(t,idx)}
                                        >
                                        </i> */}
                                        <i 
                                          onClick={() =>deleteGallery(t._id,idx)}
                                          className="fa fa-trash"></i>
                                    </td>
                                </tr>)
                                :
                                <tr>
                                    <td colSpan={4}>No Records Found..</td>
                                </tr>
                            }
                        </tbody>
                    </table>
                </div>
        </div>
        <div className="modal fade" data-bs-backdrop="static" data-bs-keyboard="false" id="editModalPop">
              <div className="modal-dialog modal-dialog-centered">
                  <div className="modal-content">
                      <div className="modal-header">
                          <h5 className="modal-title" id="staticBackdropLabel">Edit Trainer</h5>
                          <button
                              type="button"
                              className="btn-close"
                              data-bs-dismiss="modal"
                              //onClick={() => handleReset()} 
                              aria-label="Close"></button>
                      </div>
                      <div className="modal-body">
                          {
                              status ?
                                  <div className="container">
                                      <div className="row my-3">
                                          <div className="col-md-12 col-sm-12 d-flex flex-column justify-content-center border-1">
                                              <div className="success-img"></div>
                                              <h4 className="text-success text-center m-3">Row Updated Successfully !!!</h4>
                                          </div>
                                      </div>
                                  </div>
                                  :
                                  <div className="container">
                                      <div className="row">
                                      <div className="col-md-6 col-md-12">
                                              <form onSubmit={handleUpdateGallery} enctype="multipart/form-data">
                                                  <div class="container">
                                                      <div class="mb-3">
                                                          <label for="name" class="form-label">Trainer Name</label>
                                                          <input
                                                              type="text"
                                                              class="form-control"
                                                              id="name"
                                                              name="img_name"
                                                              value={imgName}
                                                              onChange={e => handleEditGallery(e)}
                                                              placeholder="Enter name" autoComplete='off' />
                                                      </div>
                                
                                                      <div class="mb-3">
                                                          <label for="image" class="form-label">Upload Image</label>
                                                          <input
                                                              type="file"
                                                              class="form-control"
                                                              id="image"
                                                              name="gallery_pic"
                                                              onChange={e => setProfilePic(e.target.files[0])}
                                                              placeholder="Upload Image" />
                                                      </div>
                                                      <button
                                                          type="submit"
                                                          class="btn btn-primary">Submit</button>

                                                  </div>
                                              </form>

                                          </div>
                                      </div>
                                  </div>
                          }

                      </div>
                      <div className="modal-footer">
                          {
                              status ?
                                  <button
                                      type="button"
                                      className="btn btn-secondary"
                                      //onClick={() => handleReset()} 
                                      data-bs-dismiss="modal">Close</button>
                                  :
                                  null
                          }

                      </div>
                  </div>
              </div>
          </div>
        <ToastContainer/>
    </div>
  )
}

export default ManageGallery